import { useQuery, gql } from '@apollo/client';

export const GET_ALL_HEALTH_INSURANCE = gql`
  query getAllHealthInsurance {
    getAllHealthInsurance {
      _id
      name
    }
  }
`;

export const useGetAllHealthInsurance = () => {
  const { data, loading } = useQuery(GET_ALL_HEALTH_INSURANCE, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    healthInsurance: data?.getAllHealthInsurance || [],
    loading,
  };
};
